
import { toast } from "@/components/ui/use-toast";

const API_URL = process.env.NODE_ENV === 'production' 
  ? 'https://api.agenteia.anoteja.com.br'
  : 'http://localhost:8080';

export const checkServerStatus = async () => {
  try {
    const response = await fetch(`${API_URL}/status`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    console.log('Server status:', data);
    
    return {
      isOnline: data.status === 'online',
      whatsappConnected: data.whatsappConnected || false,
      telegramConnected: data.telegramConnected || false,
      activeConnections: data.activeConnections || 0,
      environment: data.environment,
      timestamp: data.timestamp
    };
  } catch (error) {
    console.error('Error checking server status:', error);
    toast({
      variant: "destructive",
      title: "Erro ao verificar status do servidor",
      description: "Não foi possível conectar ao servidor. Verifique sua conexão."
    });
    return {
      isOnline: false,
      whatsappConnected: false,
      telegramConnected: false,
      activeConnections: 0,
      environment: 'unknown',
      timestamp: new Date().toISOString()
    };
  }
};
